import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.approval-policy', {
        url: '/approval-policy',
        component: 'companyManageApplicationApprovalPolicy',
        resolve: {approvalPolicyList},
    });
}

/** @ngInject */
function approvalPolicyList(ApprovalPoliciesService, companyId) {
    return ApprovalPoliciesService.getPoliciesForCompany(companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/approval-policy/approval-policy.state.js